import React, { useContext, useRef, useState } from 'react'
import { Button, ListMenu, ListMenuButton, NotificationManagerContext,
   Popover, View } from 'oio-react'
import { AddIcon, ArrowDownIcon } from 'assets/icons'
import { useMe, useOrganization, useUpdateRelationship } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeSubscribeButton = () => {
   const relationshipPopoverButton = useRef(null)
   const [popoverIsOpen, setPopoverIsOpen] = useState(false)
   const { showNotification } = useContext(NotificationManagerContext)

   const { updateRelationship, mutating } = useUpdateRelationship()
   const { organization } = useOrganization()
   const { me, isLoggedIn, loading: userIsLoading } = useMe()
   const { initiative, refetchInitiative } = useContext(InitiativeHierarchyContext)
   const userIsSubscribed = initiative.currentUserRelationship?.isSubscribed

   if (userIsLoading || !isLoggedIn) {
      return null
   }

   // Button Props
   const { highlightColor: buttonColor } = organization.theme
   const buttonTextColor = '#fff'

   const handleToggleSubscription = async () => {
      try {
         await updateRelationship({
            entityType: 'initiative',
            entityId: initiative.id,
            userId: me.id,
            elements: [{
               operation: 'setSubscribedEvents',
               setSubscribedEvents: userIsSubscribed ? [] : ['threadUpdates']
            }]
         })

         refetchInitiative()
      } catch (error) {
         showNotification({
            message: error.message || 'An error occured while updating your subscription settings',
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <>
         {!userIsSubscribed && (
            <Button
               color={buttonColor}
               mode={mutating ? 'loading' : 'normal'}
               name="Follow"
               onClick={handleToggleSubscription}
               padding="20px"
               size="md"
               textColor={buttonTextColor}
               textTransform="capitalize">
               <View marginRight="12px">
                  <AddIcon
                     width="12px"
                     height="12px"
                     color={buttonTextColor}
                     strokeWidth="2px"
                  />
               </View>
            </Button>
         )}
         {userIsSubscribed && (
            <>
               <Button
                  ref={relationshipPopoverButton}
                  color={buttonColor}
                  mode={mutating ? 'loading' : 'normal'}
                  name="Following"
                  onClick={() => setPopoverIsOpen(true)}
                  padding="20px"
                  size="md"
                  textColor={buttonTextColor}>
                  <View marginRight="9px">
                     <ArrowDownIcon
                        width="10px"
                        height="10px"
                        color={buttonTextColor}
                        strokeWidth="3px"
                     />
                  </View>
               </Button>
               <Popover
                  anchorElement={relationshipPopoverButton.current}
                  anchorOriginHorizontal="right"
                  anchorOriginVertical="top"
                  width="220px"
                  margin="12px[a-c]"
                  borderRadius="6px"
                  onBodyClick={() => {
                     setPopoverIsOpen(false)
                  }}
                  open={popoverIsOpen}>
                  <View style={{ overflow: 'hidden' }}>
                     <ListMenu buttonSize="md">
                        <ListMenuButton
                           onClick={handleToggleSubscription}
                           name="Unfollow this discussion"
                        />
                     </ListMenu>
                  </View>
               </Popover>
            </>
         )}
      </>
   )
}

export default InitiativeSubscribeButton
